import React from 'react';
import Spinner from 'react-spinkit';

/**
 * A generic loading page.
 */
const Loading = () => (
  <Spinner name='circle' className='spinner' fadeIn='none' />
);

export default Loading;



// WEBPACK FOOTER //
// ./src/containers/pages/loading.js